import { Methods } from '../config';
import request from '../utils/Request';
// import { Methods } from '../config';

const baseURL = 'joker';

const jokerService = {
  getGroups: (type) => {
    return request({
      resource: `${baseURL}/groups/${encodeURIComponent(type)}`,
    });
  },

  getLineFields: (type) => {
    return request({
      resource: `${baseURL}/lineFields/${encodeURIComponent(type)}`,
    });
  },

  getFields: (type) => {
    return request({
      resource: `${baseURL}/fields/${encodeURIComponent(type)}`,
    });
  },

  upsertGroup: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/group`,
      data,
    });
  },

  getEditorFields: (type, groupId) => {
    return request({
      resource: `${baseURL}/fields/${encodeURIComponent(type)}/${encodeURIComponent(groupId)}`,
    });
  },

  upsertEditorField: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      data,
    });
  },

  checkJokerFieldDelete: (id, type) => {
    return request({
      resource: `${baseURL}/checkFieldDelete/${encodeURIComponent(id)}/${encodeURIComponent(type)}`,
    });
  },

  checkJokerValuesDelete: (id, type) => {
    return request({
      resource: `${baseURL}/checkValuesDelete/${encodeURIComponent(id)}/${encodeURIComponent(type)}`,
    });
  },
};

export default jokerService;
